module.exports = __webpack_public_path__ + "img/4.65c49083.png";